export class Articles {
  

    
    titolo:string;
    sottotitolo:string;
    CodArticolo:string;
    articoloBreve: string;
}